import * as API from "../../api";
import * as ActionTypes from "../action-types";
import { message } from "antd";

// Constants and config
import { TIME } from "../../util";

// Redux actions
import { setLoadingBilling, unsetLoadingBilling } from "./style";

const { lastNDay, latestTime } = TIME

export const get_billing_timeframe_request = () => (dispatch) => {
  dispatch(
    get_all_billing_request(lastNDay(90), latestTime)
  );
};

export const get_all_billing_request = (
  startTime, endTime
) => (dispatch) => {
  dispatch(setLoadingBilling());

  API.getBillingTimeFrameAll({ 
   startTime,
   endTime,
  })
    .then((info) => {
      const { status, msg, billings } = info;
      if (status === 200) {
        dispatch(get_all_billing_success(billings));
        message.success("Successfully get the billing data");
      } else {
        message.warning(msg);
      }
    })
    .finally(() => {
      dispatch(unsetLoadingBilling());
    });
};

const get_all_billing_success = (billing) => {
  return {
    type: ActionTypes.BILLING_GET_ALL,
    billing,
  };
};

export const get_billing_timeframe_by_coid_request = (coid) => (dispatch) => {
  dispatch(
    get_billing_timeframe_by_coid_all_request(coid, lastNDay(90), latestTime)
  );
};

export const get_billing_timeframe_by_coid_all_request =
  (coid, startTime, endTime) => (dispatch) => {
    dispatch(setLoadingBilling());

    API.getBillingTimeFrameByCoid({
      coid,
      startTime,
      endTime,
    })
      .then((info) => {
        const { status, billings, msg } = info;

        if (status === 200) {
          dispatch(get_billing_timeframe_by_coid_all_success(billings));
          message.success("Successfully get the billing data");
        } else {
          message.warning(msg);
        }
      })
      .finally(() => {
        dispatch(unsetLoadingBilling());
      });
  };

  const get_billing_timeframe_by_coid_all_success = (billing) => {
    return {
      type: ActionTypes.BILLING_GET_ALL_BY_COID,
      billing,
    };
  };


export const update_billing_request = (items, role, cb) => (dispatch) => {
  dispatch(setLoadingBilling());

  API.updateBilling(items)
    .then((data) => {
      const { status, billing, msg } = data;
      if (status === 200) {
        dispatch(update_billing_success(billing, role));
        message.success("Update billing successfully");
      } else {
        message.warning(msg);
      }
    })
    .finally(() => {
      cb();
      dispatch(unsetLoadingBilling());
    });
};

export const payback_billing_request = (items, role, cb) => (dispatch) => {
  dispatch(setLoadingBilling());

  API.paybackBilling(items)
    .then((data) => {
      const { status, billing, msg } = data;
      if (status === 200) {
        dispatch(update_billing_success(billing, role));
        message.success(msg);
      } else {
        message.warning(msg);
      }
    })
    .finally(() => {
      cb();
      dispatch(unsetLoadingBilling());
    });
};

const update_billing_success = (billing, role) => {
  return {
    type: ActionTypes.UPDATE_BILLING,
    billing,
    role
  };
};

export const bulk_publish_billing_request = (items, cb) => (dispatch) => {
  dispatch(setLoadingBilling());

  API.bulkPublish(items)
    .then((data) => {
      const { status, billings, msg } = data;
      if (status === 200) {
        dispatch(bulk_publish_billing_success(billings));
        message.success(msg);
      } else {
        message.warning(msg);
      }
    })
    .finally(() => {
      cb();
      dispatch(unsetLoadingBilling());
    });
};

const bulk_publish_billing_success = (billings) => {
  return {
    type: ActionTypes.BULK_PUBLISH,
    billings,
  };
};
